export const MOST_RECENT_RESUME_ID = 'mostRecentResumeId';
export const CREATED_AT = 'createdAt';
export const STRIPE_CUSTOMER_ID = 'stripeCustomerId';
